import { Unavailability, RequestedUnavailability } from "@models";
import { unavailabilityService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class UnavailabilityStore {
  unavailability = new Map<number, Unavailability>();
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (request: RequestedUnavailability) => {
    this.setLoading(true);
    try {
      const response = await unavailabilityService.getAll(request);
      runInAction(() => {
        response.forEach((unavailability) => {
          this.unavailability.set(unavailability.id, unavailability);
        });
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      this.setLoading(false);
    }
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  clearUnavailability = () => {
    runInAction(() => {
      this.unavailability.clear();
    });
  };
}
